import orderRequest from "@/request/orderRequest";
import url from "postcss-url";

// const urls = {
//   login: "/user/login", // 登录
//   logout: "/user/update/token", // 登出
//   luckGo: "/user/prize/draw", // 抽奖
//   luckNum: "/user/prize/draw/count", // 获取抽奖次数
//   luckUserList: "/user/prize/user", // 获取中奖名单
//   getUserStatus: "/user/user/status", // 获取用户状态
//   getInvitation: "/user/user/code", // 获取邀请信息
//   luckRecordList: "/user/prize/user/list", // 获取中奖记录
//   getRealOrderNum: "/user/user/total", // 获取真实预约人数
//   getVerificationCode: "/user/verify/code", // 验证码
//   updateUserStatus: "/user/user/update/status", // 立即预约
//   getUserInfoCode: "/user/getUserInfoCode", // 获取主播码
//   userInfoCode: "/user/userInfoCode", // 添加主播信息
// loginShortTime: "/api/login/shortTime", // 临时登录
// // };

const urls = {
  login: "/api/login", // 登录
  logout: "/api/update/token", // 登出
  luckGo: "/api/prize/draw", // 抽奖
  luckNum: "/api/prize/draw/count", // 获取抽奖次数
  luckUserList: "/api/prize/user", // 获取中奖名单
  getUserStatus: "/api/user/status", // 获取用户状态
  getInvitation: "/api/user/code", // 获取邀请信息
  luckRecordList: "/api/prize/user/list", // 获取中奖记录
  getRealOrderNum: "/api/user/total", // 获取真实预约人数
  getVerificationCode: "/api/verify/code", // 验证码
  updateUserStatus: "/api/user/update/status", // 立即预约
  getUserInfoCode: "/api/user/getUserInfoCode", // 获取主播码
  userInfoCode: "/api/user/userInfoCode", // 添加主播信息
  loginShortTime: "/api/login/shortTime", // 临时登录
  getAnswers: "/api/answer/getAnswers", // 获取问答答案
};

const orderApi = {
  login: (params) => {
    return orderRequest({
      url: urls.login,
      method: "post",
      params: {
        phone: params.phone,
        code: params.code,
        extendCode: params.extendCode,
      },
    });
  },
  //临时登录
  loginShortTime: (params) => {
    return orderRequest({
      url: urls.loginShortTime,
      method: "post",
      params: {
        phone: params.phone,
      },
    });
  },
  logout: (params) => {
    return orderRequest({
      url: urls.logout,
      method: "post",
      params,
    });
  },
  luckNum: (params) => {
    return orderRequest({
      url: urls.luckNum,
      method: "post",
      params,
    });
  },
  luckUserList: () => {
    return orderRequest({
      url: urls.luckUserList,
      method: "post",
    });
  },

  getUserStatus: (params) => {
    return orderRequest({
      url: urls.getUserStatus,
      method: "post",
      params,
    });
  },

  luckRecordList: (params) => {
    return orderRequest({
      url: urls.luckRecordList,
      method: "post",
      params,
    });
  },
  
  luckGo: (params) => {
    return orderRequest({
      url: urls.luckGo,
      method: "post",
      params,
    });
  },
  InvitePlayers: (params) => {
    return orderRequest({
      url: urls.InvitePlayers,
      method: "post",
      params,
    });
  },
  getInvitation: (params) => {
    return orderRequest({
      url: urls.getInvitation,
      method: "post",
      params,
    });
  },
  getVerificationCode: (params) => {
    return orderRequest({
      url: urls.getVerificationCode,
      method: "post",
      params,
    });
  },
  getRealOrderNum: () => {
    return orderRequest({
      url: urls.getRealOrderNum,
      method: "get",
    });
  },
  updateUserStatus: (params) => {
    return orderRequest({
      url: urls.updateUserStatus,
      method: "post",
      params,
    });
  },
  userInfoCode: (params) => {
    return orderRequest({
      url: urls.userInfoCode,
      method: "post",
      params,
    });
  },

  getUserInfoCode: (params) => {
    return orderRequest({
      url: urls.getUserInfoCode,
      method: "post",
      params,
    });
  },

  getAnswers: (params) => {
    return orderRequest({
      url: urls.getAnswers,
      method: "post",
      params,
    });
  },
};


export default orderApi;
